module.exports = __webpack_public_path__ + "static/media/tg.43712dd6.png";